(function () {
  const gallerySelector = '[data-product-gallery][data-desktop-slider-layout="true"]';
  let resizeTimer = null;

  function isDesktop() {
    if (typeof window.isScreenSizeLarge === 'function') {
      return window.isScreenSizeLarge();
    }

    return window.innerWidth >= 1025;
  }

  function syncGallery(gallery) {
    if (!gallery || !window.Flickity) return;

    const flickity = window.Flickity.data(gallery);

    if (!flickity) return;

    const desktop = isDesktop();
    const desiredCellAlign = desktop ? 'right' : 'center';
    const desiredPercentPosition = !desktop;

    if (
      flickity.options.cellAlign === desiredCellAlign &&
      flickity.options.percentPosition === desiredPercentPosition
    ) {
      return;
    }

    flickity.options.cellAlign = desiredCellAlign;
    flickity.options.percentPosition = desiredPercentPosition;
    flickity.resize();

    if (typeof flickity.positionSliderAtSelected === 'function') {
      flickity.positionSliderAtSelected();
    }
  }

  function syncAll(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(gallerySelector).forEach(syncGallery);
  }

  function wrapEnableGallery() {
    if (
      !window.productPage ||
      typeof window.productPage.enableGallery !== 'function' ||
      window.productPage.enableGallery.__cpDesktopAlignWrapped
    ) {
      return;
    }

    const originalEnableGallery = window.productPage.enableGallery;

    function wrappedEnableGallery($productGallery) {
      const result = originalEnableGallery.apply(this, arguments);
      const gallery = $productGallery && $productGallery[0] ? $productGallery[0] : null;

      if (gallery) {
        window.requestAnimationFrame(function () {
          syncGallery(gallery);
        });
      }

      return result;
    }

    wrappedEnableGallery.__cpDesktopAlignWrapped = true;
    window.productPage.enableGallery = wrappedEnableGallery;
  }

  function scheduleSync(root) {
    window.requestAnimationFrame(function () {
      wrapEnableGallery();
      syncAll(root);
    });
  }

  wrapEnableGallery();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scheduleSync(document);
    });
  } else {
    scheduleSync(document);
  }

  window.addEventListener('load', function () {
    scheduleSync(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    scheduleSync(event.target);
  });

  window.addEventListener('resize', function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      scheduleSync(document);
    }, 150);
  });
})();
